// src/pages/HomePage.jsx
import React from 'react';
import Meta from '../../components/common/Meta';
//import ImageCarousel from '../components/ImageCarousel';
import ProfilesPage from '../profiles/ProfilesPage';
//import ProductImageSlider from '../components/ProductImageSlider';

function HomePage() {
  return (
    <>
      <Meta page="home" />
      <div>
        {/* <ImageCarousel /> */}
        <ProfilesPage />
        {/*<ProductImageSlider /> */}
      </div>
    </>
  );
}

export default HomePage;